import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "customer-reviews__rating-text-container" }
const _hoisted_2 = { class: "customer-reviews__rating-text" }
const _hoisted_3 = {
  key: 0,
  class: "customer-reviews__rating-text-label"
}
const _hoisted_4 = { class: "customer-reviews__rating-text-percentage" }
const _hoisted_5 = { class: "customer-reviews__recommendation" }
const _hoisted_6 = { class: "customer-reviews__recommendation-reviews" }

import { pluralize } from '@utils/utils';
interface Props {
	ratingLabel: string;
	recommendationRate: string;
	ratingCount: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerReviewsRatingContent',
  props: {
    ratingLabel: {},
    recommendationRate: {},
    ratingCount: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      (_ctx.ratingLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.ratingLabel), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.recommendationRate), 1 /* TEXT */)
    ]),
    _createElementVNode("span", _hoisted_5, [
      _cache[0] || (_cache[0] = _createTextVNode(" Weiterempfehlung")),
      _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(_unref(pluralize)(_ctx.ratingCount, 'Bewertung', 'Bewertungen')) + ") ", 1 /* TEXT */)
    ])
  ]))
}
}

})